import { TriangleAlert } from 'lucide-react';

import { cx } from '@/lib/cx';
import { Status } from '@/ui/components/status';
import { type EstadoCaptura } from '@fiscoai/contracts';

import { acaoSugerida } from './textos';
import { type Visual, VISUAL_SITUACAO } from './visual';

/** Selo com ícone e texto; o ícone gira na busca em andamento (parado com movimento reduzido). */
export function SeloCaptura({ visual }: { visual: Visual }) {
  const { Icone } = visual;
  return (
    <Status
      tom={visual.tom}
      icone={<Icone className={cx(visual.girando && 'animate-spin motion-reduce:animate-none')} />}
    >
      {visual.rotulo}
    </Status>
  );
}

/**
 * Situação da captura de uma empresa: selo + a frase pronta do servidor. Quando começa a buscar,
 * o leitor de tela ouve (região `polite` sempre montada, preenchida só durante a busca).
 */
export function SituacaoCaptura({ estado }: { estado: EstadoCaptura }) {
  const buscando = estado.situacao === 'EXECUTANDO';
  return (
    <span className="inline-flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      <SeloCaptura visual={VISUAL_SITUACAO[estado.situacao]} />
      <span className="text-sm text-texto-suave">{estado.descricao}</span>
      <span className="sr-only" aria-live="polite">
        {buscando ? `Buscando notas na SEFAZ para ${estado.empresa.nome}` : ''}
      </span>
    </span>
  );
}

/** Faixa de alerta quando a SEFAZ indica outro consumidor do mesmo CNPJ (656 "use o ultNSU"). */
export function AvisoOutroConsumidor({ className }: { className?: string }) {
  return (
    <p
      role="note"
      className={cx(
        'flex items-start gap-2 rounded-controle border border-alerta/40 bg-alerta-suave px-3 py-2 text-sm',
        className,
      )}
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0 text-alerta" aria-hidden />
      Outro sistema parece consultar este CNPJ na SEFAZ. Combine qual sistema faz a consulta
      automática.
    </p>
  );
}

/** Próximo passo quando a última busca deu erro (nada fora do erro). */
export function AcaoSugerida({ estado }: { estado: EstadoCaptura }) {
  const acao = acaoSugerida(estado);
  return acao ? <p className="text-sm text-texto-suave">{acao}</p> : null;
}
